module.exports = __webpack_public_path__ + "static/media/github.4eb836ff.png";